var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numberCircle"},[_vm._v(" "+_vm._s(_vm.duration.toFixed(2))+" "),_c('span',{staticClass:"circle-unit"},[_vm._v("Sec")])])}
var staticRenderFns = []

export { render, staticRenderFns }